<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="person-search">
      <a-form layout="inline">
        <a-form-item label="操作人">
          <a-input class="form-cell" type="text" placeholder="操作人" v-model="queryParam.operator"
            @change="currentPage = 1"></a-input>
        </a-form-item>

        <a-form-item label="模块" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-select class="form-cell" placeholder="请选择模块" v-model="queryParam.operateModule" @change="currentPage = 1">
            <a-select-option v-for="(item, index) in operateModuleList" :value="item" :key="index">{{ item
              }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="时间">
          <a-range-picker format="YYYY-MM-DD HH:mm:ss" v-model="queryParam.time" :showTime="{
            hideDisabledOptions: true,
            defaultValue: [
              moment('00:00:00', 'HH:mm:ss'),
              moment('23:59:59', 'HH:mm:ss'),
            ],
          }" @change="currentPage = 1" />
          <a-button style="margin-left: 10px !important" size="small" @click="today()">今</a-button>
          <a-button style="margin-left: 10px !important" size="small" @click="yesterday()">昨</a-button>
          <a-button style="margin-left: 10px !important" size="small" @click="lastWeek()">最近7天</a-button>
          <a-button style="margin-left: 10px !important" size="small" @click="lastMonth()">最近30天</a-button>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchOperateLog()">查询</a-button>
          <a-button type="primary" @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="person-oper"></div>

    <!-- 表格数据 -->
    <a-table :columns="columns" :dataSource="dataSource" :loading="loading" :pagination="pagination" class="c-table"
      @change="handleTableChange" :rowKey="getRowKey">
      <!-- <span slot="operator" slot-scope="text, record">
        {{ record.nickname ? record.nickname : record.mobile }}
      </span> -->
      <template slot="operator" slot-scope="text, record">
        <a-popover title="">
          <template slot="content">
            <p>{{ record.nickname ? record.nickname : record.mobile }}</p>
          </template>
          <div class="ellipsis w1">{{ record.nickname ? record.nickname : record.mobile }}</div>
        </a-popover>
      </template>
      <template slot="module" slot-scope="text, record">
        <a-popover title="">
          <template slot="content">
            <p>{{ record.module }}</p>
          </template>
          <div class="ellipsis w2">{{ record.module }}</div>
        </a-popover>
      </template>
      <template slot="methodName" slot-scope="text, record">
        <a-popover title="">
          <template slot="content">
            <p>{{ record.methodName }}</p>
          </template>
          <div class="ellipsis w3">{{ record.methodName }}</div>
        </a-popover>
      </template>
      <template slot="logName" slot-scope="text, record">
        <a-popover title="">
          <template slot="content">
            <p>{{ record.logName }}</p>
          </template>
          <div class="ellipsis w4">{{ record.logName }}</div>
        </a-popover>
      </template>


      <template slot="content" slot-scope="text, record">
        <a-popover title="">
          <template slot="content">
            <p>{{ record.content }}</p>
          </template>
          <div class="ellipsis w5">{{ record.content }}</div>
        </a-popover>
      </template>
    </a-table>
  </div>
</template>
<script>
import CTable from '../../components/CTable'
import operateLog from '../../api/operateLog'
import moment from 'moment'

const columns = [
  {
    title: '操作时间',
    width: 180,
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
  },
  {
    title: '操作人',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作模块',
    dataIndex: 'module',
    key: 'module',
    scopedSlots: { customRender: 'module' }
  },
  {
    title: '方法名称',
    dataIndex: 'methodName',
    key: 'methodName',
    scopedSlots: { customRender: 'methodName' }
  },
  {
    title: '操作名称',
    dataIndex: 'logName',
    key: 'logName',
    scopedSlots: { customRender: 'logName' }
  },
  {
    title: '操作内容',
    dataIndex: 'content',
    key: 'content',
    // width: 800,
    scopedSlots: { customRender: 'content' },
  },
]

export default {
  name: 'operateLogList',
  data() {
    return {
      moment,
      operateModuleList: [],
      queryParam: {
        operator: '',
        operateModule: undefined,
        time: [],
        pageSize: 10,
      }, //查询参数
      dataSource: [],
      currentPage: 1,
      columns,
      loading: false,
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      },
    }
  },
  components: {
    CTable,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    today() {
      this.currentPage = 1
      this.queryParam.time = [moment().startOf('day'), moment()]
    },
    yesterday() {
      this.currentPage = 1
      this.queryParam.time = [
        moment().subtract(1, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day'),
      ]
    },
    lastWeek() {
      this.currentPage = 1
      this.queryParam.time = [moment().subtract(7, 'days'), moment()]
    },
    lastMonth() {
      this.currentPage = 1
      this.queryParam.time = [moment().subtract(30, 'days'), moment()]
    },
    searchOperateLog() {
      this.loading = true
      let params = this.queryParam
      let newParms = {}
      let operator = params.operator ? params.operator : ''
      let operateModule = params.operateModule ? params.operateModule : ''
      let startTime = params.time[0] ? moment(params.time[0].toDate()).format('YYYY-MM-DD HH:mm:ss') : ''
      let endTime = params.time[1] ? moment(params.time[1].toDate()).format('YYYY-MM-DD HH:mm:ss') : ''
      if (operator != '') {
        newParms.operator = operator
      }
      if (operateModule != '') {
        newParms.operateModule = operateModule
      }
      if (startTime != '') {
        newParms.operateStartTime = startTime
      }
      if (endTime != '') {
        newParms.operateEndTime = endTime
      }
      newParms.currentPage = this.currentPage
      newParms.pageSize = 10
      //   newParms.sorter = "t.gmt_create-desc";
      console.log(newParms, '参数')
      operateLog.list(newParms).then(res => {
        console.log(res, 'res_____')
        this.pagination = res.data.pagination
        this.dataSource = res.data.list
        this.loading = false
      })
    },
    //获取模块列表
    getModuleList() {
      operateLog.moduleList().then((res) => {
        this.operateModuleList = res.data
      })
    },
    reset(){
      this.currentPage = 1
      this.queryParam = {
        operator: '',
        operateModule: undefined,
        time: [],
        pageSize: 10,
      }
      this.searchOperateLog()
    },
    handleTableChange(pagination, filters, sorter) {
      this.currentPage = pagination.current
      console.log(this.currentPage, 'pagination');
      this.searchOperateLog()
    },
  },
  created() {
    this.getModuleList()
    this.searchOperateLog()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.person-oper {
  margin: 20px 0px 30px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.w1 {
  max-width: 100px;
}
.w2 {
  max-width: 100px;
}
.w3 {
  max-width: 100px;
}
.w4 {
  max-width: 100px;
}
.w5 {
  max-width:500px;
}
</style>
